export enum EmailVerificationErrorMessages {
	NETWORK_LOST = 'email-verification-error_connection-lost',
	EMAIL_USED = 'email-verification-error_email-used',
	INCORRECT_CODE = 'email-verification-error_incorrect-code',
	MAX_ATTEMPT = 'email-verification-error_max-attempt',
	MISSING_VERIFICATION =  'email-verification-error_missing-verification',
	UKNOWN_ERROR = 'common_unknown-error'
}
